import React from 'react'
import './termasAdnCondition.css'
import INCSUBFooter from '../../components/Footer/Footer'
import INCSUBCommonHeading from '../../commonComponents/commonHeading/commonHeading'

function INCSUBTermsAndConditions() {
  return (
    <div className='INCSUTermsAndConditions_ctn'>
      <div className='INCSUTermsAndConditions_ctn_content'>
        <div className='INCSUTermsAndConditions_ctn_content_div'>
          <div className='INCSUTermsAndConditions_ctn_content_div_first' style={{ width: '100%', boxSizing: 'border-box' }}>

            <INCSUBCommonHeading text={'Terms & Conditions'} height={0} top={4} left={64} />

            <div className='INCSUTermsAndConditions_ctn_content_div_first_head' style={{ color: '#fff', fontSize: '28px', fontWeight: '700', marginTop: '20px', marginBottom: '5px' }}>
              TheSubscription - Terms & Conditions
            </div>

            <div style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '14px', fontWeight: '500', marginBottom: '20px' }}>
              Last Updated: 29/5/26
            </div>

            <p className='INCSUTermsAndConditions_ctn_content_div_first_para' style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '16px', lineHeight: '1.6', marginBottom: '30px' }}>
              Welcome to TheSubscription, a digital marketplace that connects users seeking access to subscription services with users offering unused seats from legally purchased multi-user plans. By accessing or using TheSubscription, you agree to comply with these Terms & Conditions.
            </p>

            {/* 1. Eligibility & Account Responsibility */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                1. Eligibility & Account Responsibility
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Users must provide accurate and complete information during registration.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Available only to users above 18 years.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription is not responsible for losses caused by unauthorized account access resulting from user negligence.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Providing false, misleading, or fraudulent information may result in account suspension or termination.
                </li>
              </ul>
            </div>

            {/* 2. Nature of the Platform */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                2. Nature of the Platform
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription operates as a digital marketplace facilitator.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription does not own, purchase, sell, resell, or distribute subscriptions.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Users exchange access to available seats in legally purchased multi-user plans.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Access provided through the platform does not transfer ownership of any subscription.
                </li>
              </ul>
            </div>

            {/* 3. Hosts (Pool Owners) */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                3. Hosts (Pool Owners)
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '15px', fontWeight: '500', marginBottom: '8px' }}>
                Hosts must:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0 0 12px 0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Offer access only from legally purchased multi-user, family, or similar plans that support multiple users.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Provide accurate pool information and pricing.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Deliver access within the timeline specified in their listing.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Maintain active and functional access throughout the purchased duration.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Follow all applicable platform policies.
                </li>
              </ul>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                Unauthorized, cracked, trial, stolen, or illegally obtained access is strictly prohibited.
              </p>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', margin: '0' }}>
                TheSubscription may remove listings or suspend Hosts for policy violations.
              </p>
            </div>

            {/* 4. Members (Pool Participants) */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                4. Members (Pool Participants)
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                Members purchase temporary access, not ownership.
              </p>
              <p style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '15px', fontWeight: '500', marginBottom: '8px' }}>
                Members must:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Use access only for personal purposes.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Follow pool-specific rules established by the Host.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Comply with applicable third-party platform policies.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Sharing, reselling, transferring, or misusing access obtained through TheSubscription is prohibited.
                </li>
              </ul>
            </div>

            {/* 5. Payments, Platform Fees & Withdrawals */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                5. Payments, Platform Fees & Withdrawals
              </div>

              <div style={{ marginLeft: '10px', marginBottom: '15px' }}>
                <div style={{ color: '#fff', fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
                  Payments
                </div>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                  <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                    All payments are processed through authorized third-party payment service providers.
                  </li>
                  <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                    TheSubscription does not directly process or store sensitive payment credentials such as card numbers, UPI PINs, banking passwords, or authentication details.
                  </li>
                </ul>
              </div>

              <div style={{ marginLeft: '10px', marginBottom: '15px' }}>
                <div style={{ color: '#fff', fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
                  Platform Fees
                </div>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                  <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                    TheSubscription may charge platform fees, service fees, convenience fees, or promotional fees where applicable.
                  </li>
                  <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                    Any applicable fees will be displayed before completing a transaction.
                  </li>
                </ul>
              </div>

              <div style={{ marginLeft: '10px', margin: '0' }}>
                <div style={{ color: '#fff', fontSize: '16px', fontWeight: '600', marginBottom: '8px' }}>
                  Host Earnings & Withdrawals
                </div>
                <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                  <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                    Member payments may be temporarily held to facilitate transaction verification, dispute resolution, fraud prevention, and platform security.
                  </li>
                  <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                    Host earnings become eligible for withdrawal according to applicable platform payout rules.
                  </li>
                  <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                    Withdrawals may be delayed, withheld, or reversed in cases involving disputes, suspected fraud, chargebacks, policy violations, or legal requirements.
                  </li>
                </ul>
              </div>
            </div>

            {/* 6. Refunds & Disputes */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                6. Refunds & Disputes
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Refund requests are governed by the Refund & Cancellation Policy.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription reserves the right to investigate disputes using transaction records, account activity, communication history, and other relevant information.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Refund decisions made after review are final.
                </li>
              </ul>
            </div>

            {/* 7. Communication & Platform Usage */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                7. Communication & Platform Usage
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Users should communicate through platform-approved channels whenever available.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription may monitor platform activity for security, fraud prevention, policy enforcement, and dispute resolution purposes.
                </li>
              </ul>
            </div>

            {/* 8. Privacy & Data Protection */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                8. Privacy & Data Protection
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  User information is handled in accordance with our Privacy Policy.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Personal information is collected, used, and protected to facilitate platform operations, transactions, support, security, and legal compliance.
                </li>
              </ul>
            </div>

            {/* 9. Prohibited Activities */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                9. Prohibited Activities
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '15px', fontWeight: '500', marginBottom: '8px' }}>
                Users must not:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Provide unauthorized or illegal access.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Engage in fraud, abuse, harassment, or deceptive practices.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Manipulate listings, transactions, ratings, or reviews.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Circumvent platform safeguards.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Violate applicable laws or third-party platform policies.
                </li>
              </ul>
            </div>

            {/* 10. Account Suspension & Termination */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                10. Account Suspension & Termination
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '15px', fontWeight: '500', marginBottom: '8px' }}>
                TheSubscription may suspend, restrict, or terminate accounts for:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0 0 12px 0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Policy violations
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Fraudulent activity
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Repeated complaints
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Misuse of the platform
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Legal or compliance requirements
                </li>
              </ul>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', margin: '0' }}>
                Account termination may result in the loss of access to platform services.
              </p>
            </div>

            {/* 11. Brand & Third-Party Disclaimer */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                11. Brand & Third-Party Disclaimer
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription is not affiliated with, endorsed by, sponsored by, or officially connected with any third-party subscription provider.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Brand names, trademarks, and logos are used solely for identification and reference purposes.
                </li>
              </ul>
            </div>

            {/* 12. Platform Updates */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                12. Platform Updates
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  TheSubscription may update platform features, fees, policies, or services at any time.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Continued use of the platform constitutes acceptance of any updated terms.
                </li>
              </ul>
            </div>

            {/* 13. Limitation of Liability */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                13. Limitation of Liability
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                TheSubscription acts solely as a marketplace facilitator.
              </p>
              <p style={{ color: 'rgba(255, 255, 255, 0.85)', fontSize: '15px', fontWeight: '500', marginBottom: '8px' }}>
                TheSubscription is not responsible for:
              </p>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Actions or conduct of users
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Service interruptions by third-party providers
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Policy changes made by subscription platforms
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Indirect, incidental, or consequential losses arising from platform usage
                </li>
              </ul>
            </div>

            {/* 14. Governing Law */}
            <div style={{ width: '100%', marginBottom: '25px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                14. Governing Law
              </div>
              <ul style={{ listStyleType: 'disc', paddingLeft: '20px', margin: '0' }}>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  These Terms & Conditions are governed by the laws of India.
                </li>
                <li style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                  Any disputes shall be subject to the jurisdiction of the appropriate courts in India.
                </li>
              </ul>
            </div>

            {/* 15. Contact Us */}
            <div style={{ width: '100%', marginBottom: '40px' }}>
              <div style={{ color: '#fff', fontSize: '20px', fontWeight: '600', marginBottom: '12px' }}>
                15. Contact Us
              </div>
              <p style={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '15px', lineHeight: '1.6', marginBottom: '8px' }}>
                For support or policy-related inquiries:
              </p>
              <p style={{ color: '#fff', fontSize: '16px', fontWeight: '500', margin: '0' }}>
                📧 <a href="mailto:support@thesubscription.in" style={{ color: 'rgba(255, 255, 255, 0.7)', textDecoration: 'underline' }}>support@thesubscription.in</a>
              </p>
            </div>

          </div>
        </div>
      </div>
      <INCSUBFooter />
    </div>
  )
}

export default INCSUBTermsAndConditions
